/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  Deletable,
  DeletableOptional,
  DeletableMetaI,
  DeletableTrackedI,
} from "./deletable";
import { DeletableTracked, DeletableMeta } from "./deletable";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PersonReferral,
  PersonReferralOptional,
  PersonReferralMetaI,
  PersonReferralTrackedI,
} from "./person-referral";
import { PersonReferralTracked, PersonReferralMeta } from "./person-referral";

/**
 *
 * @export
 * @interface PersonReferralDTO
 */
export interface PersonReferralDTOOptional extends DeletableOptional {
  /**
   *
   * @type {number}
   * @memberof PersonReferralDTO
   */
  assignId?: number;
  /**
   *
   * @type {string}
   * @memberof PersonReferralDTO
   */
  referralSource?: string;
  /**
   *
   * @type {boolean}
   * @memberof PersonReferralDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PersonReferralDTO
   */
  isNew?: boolean;
}

export interface PersonReferralDTO
  extends PersonReferralDTOOptional, Deletable, PersonReferral {
  /**
   *
   * @type {number}
   * @memberof PersonReferralDTO
   */
  assignId: number;
  /**
   *
   * @type {string}
   * @memberof PersonReferralDTO
   */
  referralSource?: string;
  /**
   *
   * @type {boolean}
   * @memberof PersonReferralDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PersonReferralDTO
   */
  isNew?: boolean;
}

export interface PersonReferralDTOTrackedI extends DeletableOptional {
  /**
   *
   * @type {number}
   * @memberof PersonReferralDTO
   */
  assignId?: number;
  assignIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonReferralDTO
   */
  referralSource?: string;
  referralSourceIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PersonReferralDTO
   */
  isDeleted?: boolean;
  isDeletedIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PersonReferralDTO
   */
  isNew?: boolean;
  isNewIsSet: boolean;
}

transformDatesMap.set(
  "PersonReferralDTO",
  function (model: PersonReferralDTO) {},
);

export type PersonReferralDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  assignId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  referralSource: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  isDeleted: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  isNew: PropertyMeta<MetaTypeBase<boolean>>;
}>;

export var PersonReferralDTOMeta: PersonReferralDTOMetaI =
  {} as PersonReferralDTOMetaI;
PersonReferralDTOMeta = typeMeta("PersonReferralDTO", {
  assignId: propertyMeta("assignId", false, true, true, MetaTypesBase.number),
  referralSource: propertyMeta(
    "referralSource",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  isDeleted: propertyMeta(
    "isDeleted",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  isNew: propertyMeta("isNew", false, false, false, MetaTypesBase.boolean),
});

const metaI = PersonReferralDTOMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([PersonReferralMeta]);
  metaI.assignId.inheritedFrom = PersonReferralMeta.assignId;
  metaI.referralSource.inheritedFrom = PersonReferralMeta.referralSource;
  metaI.interfaces = metaI.interfaces.concat([DeletableMeta]);
  metaI.isDeleted.inheritedFrom = DeletableMeta.isDeleted;
  metaI.isNew.inheritedFrom = DeletableMeta.isNew;
});

export class PersonReferralDTOTracked
  extends DeletableTracked
  implements PersonReferralDTOTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  assignId__I?: number = undefined;

  get assignIdIsSet() {
    return this.assignId !== undefined;
  }
  set assignIdIsSet(v: boolean) {}
  set assignId(v: undefined | number) {
    if (v !== undefined) {
      this.assignId__I = v;
      this.assignIdIsSet = true;
    } else {
      this.assignId__I = v || undefined;
      this.assignIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get assignId() {
    return this.assignId__I;
  }
  referralSource__I?: string = undefined;
  referralSourceIsSet: boolean = false;
  set referralSource(v: undefined | string) {
    if (v !== undefined) {
      this.referralSource__I = v;
      this.referralSourceIsSet = true;
    } else {
      this.referralSource__I = v || undefined;
      this.referralSourceIsSet = false;
    }
    this.changeTracker = true;
  }
  get referralSource() {
    return this.referralSource__I;
  }
  isDeleted__I?: boolean = undefined;
  isDeletedIsSet: boolean = false;
  set isDeleted(v: undefined | boolean) {
    if (v !== undefined) {
      this.isDeleted__I = v;
      this.isDeletedIsSet = true;
    } else {
      this.isDeleted__I = v || undefined;
      this.isDeletedIsSet = false;
    }
    this.changeTracker = true;
  }
  get isDeleted() {
    return this.isDeleted__I;
  }
  isNew__I?: boolean = undefined;
  isNewIsSet: boolean = false;
  set isNew(v: undefined | boolean) {
    if (v !== undefined) {
      this.isNew__I = v;
      this.isNewIsSet = true;
    } else {
      this.isNew__I = v || undefined;
      this.isNewIsSet = false;
    }
    this.changeTracker = true;
  }
  get isNew() {
    return this.isNew__I;
  }
  constructor(config?: PersonReferralDTOOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.assignIdIsSet == true && other?.assignIdIsSet == true)
      return this.assignId == other.assignId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.assignId) {
      this.assignIdIsSet = true;
    }
  }
  assignFrom(
    config: PersonReferralDTOOptional,
    options?: AssignOptions,
  ): PersonReferralDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.assignId && this.assignIdApplyFilter(optionsRequired.filter)) {
      this.assignId = config.assignId;
      if (optionsRequired.unassign) this.assignIdIsSet = false;
      else this.assignIdIsSet = true;
    }
    if (
      config.referralSource &&
      this.referralSourceApplyFilter(optionsRequired.filter)
    ) {
      this.referralSource = config.referralSource;
      if (optionsRequired.unassign) this.referralSourceIsSet = false;
      else this.referralSourceIsSet = true;
    }
    if (config.isDeleted && this.isDeletedApplyFilter(optionsRequired.filter)) {
      this.isDeleted = config.isDeleted;
      if (optionsRequired.unassign) this.isDeletedIsSet = false;
      else this.isDeletedIsSet = true;
    }
    if (config.isNew && this.isNewApplyFilter(optionsRequired.filter)) {
      this.isNew = config.isNew;
      if (optionsRequired.unassign) this.isNewIsSet = false;
      else this.isNewIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): PersonReferralDTOTrackedI {
    const cloned = {} as PersonReferralDTOTrackedI;
    if (
      this.assignIdIsSetDeep() &&
      this.assignIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.assignIdIsSet = true;
      cloned.assignId = this.assignId;
    } else {
      //cloned.assignIdIsSet = false
    }
    if (
      this.referralSourceIsSetDeep() &&
      this.referralSourceApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.referralSourceIsSet = true;
      cloned.referralSource = this.referralSource;
    } else {
      //cloned.referralSourceIsSet = false
    }
    if (
      this.isDeletedIsSetDeep() &&
      this.isDeletedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isDeletedIsSet = true;
      cloned.isDeleted = this.isDeleted;
    } else {
      //cloned.isDeletedIsSet = false
    }
    if (
      this.isNewIsSetDeep() &&
      this.isNewApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isNewIsSet = true;
      cloned.isNew = this.isNew;
    } else {
      //cloned.isNewIsSet = false
    }
    if (!isDeleted(this) && !this.assignIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): PersonReferralDTOTrackedI {
    if (!this.assignIdApplyFilter(filter)) this.assignIdIsSet = false;

    if (!this.referralSourceApplyFilter(filter))
      this.referralSourceIsSet = false;

    if (!this.isDeletedApplyFilter(filter)) this.isDeletedIsSet = false;

    if (!this.isNewApplyFilter(filter)) this.isNewIsSet = false;

    return this;
  }
  assignIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonReferralDTOMeta.assignId,
      PersonReferralDTOMeta,
      this.assignId,
      this,
    );
  }
  assignIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.assignIdIsSet && this.assignIdApplyFilter(filter)) return true;

    return false;
  }
  referralSourceApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonReferralDTOMeta.referralSource,
      PersonReferralDTOMeta,
      this.referralSource,
      this,
    );
  }
  referralSourceIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.referralSourceIsSet && this.referralSourceApplyFilter(filter))
      return true;

    return false;
  }
  isDeletedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonReferralDTOMeta.isDeleted,
      PersonReferralDTOMeta,
      this.isDeleted,
      this,
    );
  }
  isDeletedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isDeletedIsSet && this.isDeletedApplyFilter(filter)) return true;

    return false;
  }
  isNewApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonReferralDTOMeta.isNew,
      PersonReferralDTOMeta,
      this.isNew,
      this,
    );
  }
  isNewIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isNewIsSet && this.isNewApplyFilter(filter)) return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.assignIdIsSetDeep(filter)) return true;
    if (this.referralSourceIsSetDeep(filter)) return true;
    if (this.isDeletedIsSetDeep(filter)) return true;
    if (this.isNewIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
